import {
    GET_WIDGET,
    SET_WIDGET,
    API_ERROR,
    GET_WIDGETS,
    SET_WIDGETS,
    UNMOUNT_WIDGET,
    RESET_WIDGETS,
  } from "./actionTypes";
  
  export const getWidgets = () => {
    return {
      type: GET_WIDGETS,
      payload: {},
    };
  };
  
  export const setWidgets = (data) => {
    return {
      type: SET_WIDGETS,
      payload: {data},
    };
  };
  
  export const apiError = (error) => {
    return {
      type: API_ERROR,
      payload: error,
    };
  };
  
  export const getWidget = (chatId, widgetId) => {
    return {
      type: GET_WIDGET,
      payload: { chatId, widgetId },
    };
  };
  
  export const setWidget = (chatId, widgetId, data) => {
    return {
      type: SET_WIDGET,
      payload: { chatId, widgetId ,data },
    };
  };
  
  export const unMountWidget = (chatId, widgetId, unMounted = true) => {
    return {
      type: UNMOUNT_WIDGET,
      payload: { chatId, widgetId, unMounted },
    };
  }

  export const resetWidgets = () => {
    return {
      type: RESET_WIDGETS,
      payload: {},
    };
  }
  